import { ChartBarIcon, CreditCardIcon, FolderIcon, HomeIcon, InboxIcon, UsersIcon, LockClosedIcon } from '@heroicons/react/outline'
import { FaMoneyCheck, FaMoneyCheckAlt, FaPeopleCarry, FaRegCreditCard } from "react-icons/fa"
import { FcMoneyTransfer } from "react-icons/fc";
import { Disclosure } from '@headlessui/react'
import { MdPayments } from "react-icons/md";
import { FaExchangeAlt } from 'react-icons/fa';
import { SiGooglenews } from "react-icons/si";
import { MdViewModule } from "react-icons/md";
import { IoMdSettings } from "react-icons/io";
import { MdOutlineReportOff } from "react-icons/md";
import { SiAmazondynamodb } from "react-icons/si";
import { AiOutlineAudit } from "react-icons/ai";
import { FcPlanner } from "react-icons/fc";
import { BsPersonBoundingBox } from "react-icons/bs";
import icon from '../../assets/images/icon.svg'
import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { 
  MdOutlineAccountBalanceWallet
} from 'react-icons/md';


export const navigation = [
  {
    name: 'Dashboard', tag: "dashboard", moduleTag: "dashboard", icon: HomeIcon, current: false, href: '/dashboard',
    children: [{ name: 'Overview', href: "/dashboard" }]
  },
  {
    name: 'Customer Management',
    moduleTag: "customer",
    icon: UsersIcon,
    tag: "customer",
    current: false,
    children: [
      { name: 'Customers', href: '/customers' },
      {name:'New to Bank', href:'/new-to-bank'},
      { name: 'Ratings', href: '/customer/reviews' },
    ],
  },
  {
    name: 'Admin',
    icon: UsersIcon,
    moduleTag: "admin",
    current: false,
    tag: "admin",
    children: [
      { name: 'User Management', href: '/users' },
      { name: 'Create User', href: '/create/user' },
      { name: 'Roles', href: '/roles' }
    ],
  },
  {
    name:'Compliance',
    moduleTag:"accounts",
    icon: LockClosedIcon,
    tag: 'compliance',
    current: false,
    children: [
      { name: 'Compliance sheet', href: '/compliance/sheets' },
      { name: 'Log pND', href: '/compliance/log' },
    ],
  },
  {
    name: 'Account Opening',
    moduleTag: "accounts",
    icon: FolderIcon,
    current: false,
    tag: "account",
    children: [
      { name: 'Overview', href: '/accounts' },
      {name:'Minor Accounts', href:'/minor/accounts'},
      {name:'Salary Accounts', href:'/salary/accounts'},
      {name:'Business Accounts', href:'/business/accounts'},     
      {name:'Account Officer', href:'/officers'},
      {name:'User Accounts', href:'/user/accounts'},
      {name:'Upgrade Requests', href:'/user/upgrade'}
    ],
  },
  {
    name: 'Transfers',
    moduleTag: "transfers",
    icon: InboxIcon,
    tag: "transfers",
    current: false,
    children: [
      { name: 'Overview', href: '/transfers' },
      { name: 'Scheduled Transfers', href: '/scheduled/transfers' },
      {name:'Beneficiaries', href:'/beneficiaries'}
      // { name: 'General Transfers', href: '/general/transfers' },
      // { name: 'Payroll', href: '/payrolls' }
    ],
  },
   {
    name: 'Transaction Utilities',
    moduleTag: "transaction_utilities",
    icon: FaMoneyCheckAlt,
    tag: 'transaction_utilities',
    current: false,
    children: [
      { name: 'Bank Availability', href: '/utilities' },
      { name: 'Reported Accounts', href: '/fraud' },
    ],
  },
  {
    name: 'Investments',
    moduleTag: "investment",
    icon: ChartBarIcon,
    tag: "investment",
    current: false,
    children: [
      { name: 'Overview', href: '/investments' },
      { name: 'Rates Guide', href: '/investments/rate' }
    ],
  },
  //fx_transactions,treasury_bill,fgn_bonds
  {
    name: 'FX Exchange',
    moduleTag: "fx_transactions",
    icon: FaExchangeAlt,
    tag: 'fx_transactions',
    current: false,
    children: [
      { name: 'FX Transactions', href: '/transactions' },
      { name: 'FX Rates', href: '/rates' },
    ],
  },
  {
    name: 'Treasury Bill',
    icon: UsersIcon,
    moduleTag: "treasury_bill",
    current: false,
    tag: "treasury_bill",
    children: [
      { name: 'Listings', href: '/treasury' },
      { name: 'Bookings', href: '/bookings' },
      { name: 'Liquidation', href: '/liquidation' }
    ],
  },
  // fb_bonds
  {
    name: 'FGN Bonds',
    icon: UsersIcon,
    moduleTag: "fgn_bonds",
    current: false,
    tag: "fgn_bonds",
    children: [
      { name: 'Listings', href: '/fgn-bonds' },
      { name: 'Bookings', href: '/fgn-bonds/bookings' },
      { name: 'Liquidation', href: '/fgn-bonds/liquidation' },
      //{ name: 'Eligibility', href: '/fgn-bonds/eligibility' }
    ],
  },
  {
    name: 'Cheque / Draft',
    moduleTag: "cheques",
    icon: FaMoneyCheck,
    tag: "cheque",
    current: false,
    children: [
      { name: 'Confirm Cheques', href: '/confirm/cheque' },
      { name: 'Chequebook Request', href: '/request/cheque' },
      { name: 'Stop Cheques', href: '/stop/cheque' },
      { name: 'Draft Request', href: '/draft' },
    ],
  },
  {
    name: 'Cards',
    moduleTag: "cards",
    icon: FaRegCreditCard,
    tag: "cards",
    current: false,
    children: [
      { name: 'Card Requests', href: '/request/card' },
      // { name: 'Active Cards', href: '/active/card' },     
      // { name: 'Block Cards', href: '/block/card' },
    ],
  },
  {
    name: 'POS Request',
    moduleTag: "pos",
    icon: CreditCardIcon,
    tag: "pos",
    current: false,
    children: [
      { name: 'POS Requests', href: '/pos' }
    ],
  },
  {
    name: 'Payment',
    moduleTag: "payment",
    icon: MdPayments,
    tag: "payment",
    current: false,
    children: [
      { name: 'Bill Payment', href: '/payment/bill' },
      { name: 'Airtime & Data Recharge', href: '/payment/recharge' },
      {name:'Movie Subscription', href:'/payment/movies'}
    ],
  },
  {
    name: 'Deposit',
    moduleTag: "deposit",
    icon: FcMoneyTransfer,
    tag: 'deposit',
    current: false,
    children: [
      { name: 'Overview', href: '/deposits' },
    ],
  },
  {
    name: 'Withdrawals',
    icon: MdOutlineAccountBalanceWallet,
    tag: 'withdrawal',
    moduleTag: "withdrawal",
    current: false,
    children: [
      { name: 'Cash Pickup', href: '/withdrawal/pickup' },
      // { name: 'Cardless Withdrawals', href: '/withdrawals' },
    ],
  },
  {
    name: 'News',
    moduleTag: "news",
    icon: SiGooglenews,
    tag: 'news',
    current: false,
    children: [
      { name: 'All News Feed', href: '/posts' },
      { name: 'News Feed', href: '/promotion ' },
      { name: 'Push Notification', href: '/push/notification' },
      // { name: 'New Post', href: '/create/post' },
      // { name: 'Branch & ATM Locator', href: '/atm/location' }
    ],
  },
  {
    name: 'Application Module',
    tag: "application_module",
    icon: MdViewModule,
    moduleTag: "application_module",
    current: false,
    children: [
      { name: 'Overview', href: "/modules" }
    ]
  },
  {
    name: 'Application Settings',
    tag: "application_settings",
    icon: IoMdSettings,
    moduleTag: "application_settings",
    current: false,
    children: [
      { name: 'Overview', href: "/application/settings" }
    ]
  },
  {
    name: 'Complaints',
    tag: "compliant",
    icon: MdOutlineReportOff,
    moduleTag: "compliant",
    current: false,
    children: [
      { name: 'Overview', href: "/complaints" }
    ]
  },
  {
    name: 'Audit Logs',
    tag: "security",
    role: " AiOutlineAudit",
    icon: AiOutlineAudit,
    moduleTag: "security",
    current: false,
    children: [
      { name: 'Customer  AuditLogs', href: "/customer/audit" },
      { name: 'Admin  AuditLogs', href: "/admin/audit" }
    ]
  },
  {
    name: 'Organization',
    tag: "tenure",
    icon: SiAmazondynamodb,
    moduleTag: "tenure",
    current: false,
    children: [
      { name: 'Overview', href: "/organisation" }
    ]
  },
  {
    name: 'Loan',
    moduleTag:"loan",
    icon: ChartBarIcon,
    tag: 'loan',
    current: false,
    children: [
      { name: 'Personal Loans', href: '/loan/personal' },
      { name: 'Cashback Loan', href: '/loan/cashback' },
      { name: 'PayDay Loan', href: '/loan/payday' }
    ],
  },
  // {
  //   name: 'Rewards Program',
  //   moduleTag:"reward",
  //   icon: ChartBarIcon,
  //   tag: 'reward',
  //   current: false,
  //   children: [
  //     { name: 'Rewards', href: '/rewards' },
  //     { name: 'Referrals', href: '/refarrals' }
  //   ],
  // },
  {
    name:'Budget',
    moduleTag:"budget",
    icon: FcPlanner,
    tag: 'budget',
    current: false,
    children: [
      { name: 'Overview', href: '/budgets' },
    ],
  },
  {
    name:'PreOnboarding',
    moduleTag:"preonboarding",
    icon: BsPersonBoundingBox,
    tag: 'preonboarding',
    current: false,
    children: [
      { name: 'Overview', href: '/preonboard' },
    ],
  },
  {
    name:'ThirdParty',
    moduleTag: "thirdparty",
    icon: FaPeopleCarry,
    tag: 'thirdparty',
    current: false,
    children: [
      { name: 'Overview', href: '/thirdparty' },
    ],
  }
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function SideBar({ currentPage, parentPage }) {
  const [user, setUser] = useState({ firstName: "", surname: "" });
  const [userNav, setUserNav] = useState([]);

  const getDetails = () => {
    var details = sessionStorage.getItem("user");
    var userDetails = JSON.parse(details);
    var modules = [];
    modules = userDetails.moduleAssigned.split(",").map(module => module.trim());
    console.log("modules check", modules);
    console.log("moduleAssigned raw:", userDetails.moduleAssigned);
    modules.push("dashboard");
    if (userDetails === "") {
     var excluded = navigation.find(x => x.name)
    }
    
    // Debug: Check all navigation items with their moduleTags
    console.log("Navigation items with moduleTags:", navigation.map(nav => ({ name: nav.name, moduleTag: nav.moduleTag })));
    
    var navNeeded = navigation.filter(x => {
      // Only filter items that have a moduleTag property
      if (!x.moduleTag) {
        return false;
      }
      // Check for exact match first, then case-insensitive match
      const isIncluded = modules.includes(x.moduleTag) || 
                        modules.some(mod => mod.toLowerCase() === x.moduleTag.toLowerCase());
      if (x.moduleTag === "treasury_bill" || x.moduleTag === "fgn_bonds" || x.moduleTag === "fx_transactions") {
        console.log(`Checking ${x.name} (moduleTag: "${x.moduleTag}"):`, isIncluded, "modules array:", modules);
      }
      return isIncluded;
    });
    
    console.log("navNeeded after filter:", navNeeded.map(nav => nav.name));
    
    if (userDetails.role !==  "SuperAdmin" && navNeeded.includes(x => x.moduleTag === "security")) {
      var menuToremove = navNeeded.findIndex(x=>x.role && x.role === "SuperAdmin");
      navNeeded.splice(menuToremove);
    }


    setUserNav([...navNeeded])
    setUser(userDetails);
  };

  useEffect(() => {
    getDetails();
  }, []);
  return (
    <>
      <div className='hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0 btn-primary overflow-auto'>
        {/* <div className="flex flex-col flex-grow border-r border-gray-200 pt-5 pb-4 btn-primary overflow-y-auto"> */}
        <div className="flex justify-center flex-shrink-0 px-4 my-5">
          <div className='flex '>
            <img
              className="w-auto"
              src={icon}
              alt="icon"
            />
          </div>

        </div>
        <div className='flex border-y-stone-300 m-2 p-2 justify-center dashboard-avatar'>
          <div className="flex-shrink-0 mr-4 bg-white rounded-full h-10 w-10">

            <div
              className="text-center mt-2 font-extrabold"> <p> {user.firstName.charAt(0)} {user.surname.charAt(0)}</p></div>
          </div>
          <div className='flex  items-center'><p className='text-white'> {user.firstName} {user.surname}</p></div>
        </div>
        <div className="mt-5 flex-grow flex flex-col">
          <nav className="flex-1 px-2 space-y-1 bg-primary" aria-label="Sidebar">
            {userNav.map((item) =>
              !item.children ? (
                <div key={item.name}>
                  <a
                    href="#"
                    className={classNames(
                      item.current
                        ? 'bg-gray-200 text-black'
                        : 'bg-white text-black hover:bg-gray-50 hover:text-black',
                      'group w-full flex items-center pl-2 py-2 text-sm font-medium rounded-md'
                    )}
                  >
                    <item.icon
                      className={classNames(
                        item.current ? 'text-white' : 'text-black group-hover:text-black',
                        'mr-3 flex-shrink-0 h-6 w-6'
                      )}
                      aria-hidden="true" />
                    {item.name}
                  </a>
                </div>
              ) : (
                <Disclosure as="div" key={item.name} className="space-y-1">
                  {({ open }) => (
                    <>
                      <Disclosure.Button
                        className={classNames(
                          item.current
                            ? 'bg-gray-100 text-black'
                            : 'text-gray-900 hover:bg-gray-100 target:text-black hover:text-black focus:text-black active:text-black',
                          'group w-full flex items-center pl-2 pr-1 py-2 text-left text-sm font-medium rounded-md parent-menu-button'
                        )}
                      >
                        <item.icon
                          className="mr-3 flex-shrink-0 h-6 w-6 text-white group-hover:text-black"
                          aria-hidden="true"
                        />
                        <span className="parent-menu flex-1 text-gray-200 hover:text-black focus:text-black active:text-black target:text-black">{item.name}</span>
                        <svg
                          className={classNames(
                            open ? 'text-black rotate-90' : 'text-black',
                            'ml-3 flex-shrink-0 h-5 w-5 transform group-hover:text-black transition-colors ease-in-out duration-150'
                          )}
                          viewBox="0 0 20 20"
                          aria-hidden="true"
                        >
                          <path d="M6 6L14 10L6 14V6Z" fill="currentColor" />
                        </svg>
                      </Disclosure.Button>
                      <Disclosure.Panel className="space-y-1">
                        {item.children.map((subItem) => (
                          <Link key={subItem.href} to={subItem.href}>
                            <Disclosure.Button
                              as="a"
                              className="group w-full flex items-center pl-11 pr-2 py-2 text-sm font-medium text-white active:text-black   rounded-md hover:text-black hover:bg-gray-50"
                            >
                              {subItem.name}
                            </Disclosure.Button>
                          </Link>
                        ))}
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>
              )
            )}
          </nav>
        </div>
      </div>

    </>
  )
}